exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-widget=AemCspsFunds] div.csas-blue-arrow.csas-blue-arrow--left {\n  background-position-y: 98px;\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n@media all and (min-width: 768px) {\n  [data-widget=AemCspsFunds] .inlet-wrapp .csas-container-sm {\n    min-width: 800px;\n    width: 100%\n  }\n}\n", ""]);

// exports
